import { SectionLabel } from "@/components/SectionLabel";

export const QuickWonders = ({ wonders, onWonderClick }) => {
  if (!wonders || wonders.length === 0) return null;

  return (
    <div className="sidebar-block pb-9 border-b border-scoop-border fade-in" data-testid="quick-wonders">
      <SectionLabel icon="✨" title="Quick Wonders" />
      
      <div className="space-y-0">
        {wonders.map((wonder, index) => (
          <button
            type="button"
            key={wonder.id}
            className="quick-item w-full text-left flex gap-3.5 py-3 border-b border-gray-100 last:border-b-0 cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-scoop-blue rounded-sm"
            onClick={() => onWonderClick(wonder)}
            data-testid={`wonder-${wonder.id}`}
          >
            <div className="font-display text-lg font-black text-gray-200 flex-shrink-0 w-5 pt-0.5">
              {index + 1}
            </div>
            <div>
              <h4 className="font-display font-bold text-sm leading-snug text-scoop-ink mb-1">
                {wonder.title}
              </h4>
              <p className="text-[0.8rem] text-gray-600 leading-snug">
                {wonder.description}
              </p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuickWonders;
